<template>
	<v-card hover @click="$emit('click')" class="mx-auto my-1" rounded outlined>
		<v-list-item two-line @click="$emit('view-file')">
			<v-list-item-avatar>
				<v-icon color="primary" v-if="isImage">mdi-image</v-icon>
				<v-icon color="primary" v-else>{{ fileIcon || 'mdi-file' }}</v-icon>
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title v-text="title">Filnavn</v-list-item-title>
				<v-list-item-subtitle>
					Size: {{ size }} KiB
					<!-- <v-chip outlined color='secondary' small> -->
				</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-avatar v-if="showDelete">
				<v-btn @click.stop="$emit('remove')" icon color="red" large
					><v-icon>mdi-close</v-icon></v-btn
				>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import FileIcons from '@/helpers/file-icons'

export default {
	name: 'CollectionFile',
	props: {
		id: String,
		title: String,
		size: [String, Number],
		showDelete: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		fileIcon() {
			return FileIcons[this.filetype] || FileIcons['default']
		},
		isImage() {
			if (!this.title.length) return
			// Check if file extension matches image
			return this.title.includes('.png') || this.title.includes('.jpeg')
		},
	},
}
</script>

<style lang="scss" scoped>
.v-list-item__content {
	display: block;
}
</style>
